import {getData} from "../../app/utils/api";
import Form from "../../widgets/Form";
import {useEffect, useState} from "react";
import {useLoaderData, useNavigate} from "react-router-dom";
import cn from "classnames";
import "./index.scss";
import Contacts from "../../widgets/Contact";
import {SignTextBlock} from "@shared/SignTextBlock";

const START_POINT_URL = "/api/v1/anketa/start_point";

const hasNonEmptyHtmlText = (textHtml?: string): boolean =>
  Boolean(textHtml && textHtml.trim().length > 0);

const shouldWaitForStartPointDocuments = (formData: any): boolean =>
  formData?.http_code === 200 &&
  formData?.mode === "sign_text" &&
  !hasNonEmptyHtmlText(formData?.text_html);

const Anketa = () => {
  const {data, security}: any = useLoaderData();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(data);
  const isSignScreen = formData?.mode === "sign_text";
  const [userMenu, setUserMenu] = useState<
    { url: string; title: string }[] | null
  >(null);
  const [contactMenu, setContactMenu] = useState<
    { url: string; title: string }[] | null
  >(null);
  const [isWaitingForStartPointDocuments, setIsWaitingForStartPointDocuments] =
    useState(shouldWaitForStartPointDocuments(data));
  const [errorMessage, setErrorMessage] = useState("");
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (data?.user_menu) {
      void requestHandler({url: "/api/v1/anketa/user_menu", form: {}});
    }
  }, [data?.user_menu]);

  const requestHandler = async ({url, form = {}}: any) => {
    setErrorMessage("");
    setFormError("");
    setIsWaitingForStartPointDocuments(false);
    if (
      !contactMenu?.find(({url: contactMenuUrl}) => contactMenuUrl === url)
    ) {
      setContactMenu(null);
    }

    try {
      const req = await getData({
        url,
        method: "POST",
        data: {...form, security},
      });

      if (req.redirect_url) {
        navigate(req.redirect_url);
        return;
      }

      const isStartPointRequest = url === START_POINT_URL;

      if (req.user_menu) {
        const newReq = await getData({
          url: req.user_menu[0].url,
          method: "POST",
          data: {
            ...(Object.values(req.form_structure).reduce(
              (acc: any, cur: any) => ({...acc, [cur.name]: cur.value}),
              {}
            ) as {}),
            security,
          },
        });
        setUserMenu(req.user_menu);
        setFormData(newReq);
      } else if (req.contacts_menu) {
        setIsWaitingForStartPointDocuments(
          isStartPointRequest && shouldWaitForStartPointDocuments(req)
        );
        setFormData(req);
        setContactMenu(req.contacts_menu);
      } else {
        setIsWaitingForStartPointDocuments(
          isStartPointRequest && shouldWaitForStartPointDocuments(req)
        );
        setFormData(req);
      }
    } catch (e) {
      setErrorMessage("Неопознанная ошибка. Обратитесь к менеджеру.");
    }
  };

  const handleSubmit = async ({url, form}: any) => {
    setFormData(null);
    requestHandler({url, form});
  };

  const handleUserMenuData = async ({url}: any) => {
    setFormData(null);
    requestHandler({url});
  };

  const hasText = hasNonEmptyHtmlText(formData?.text_html);
  const canRenderForm =
    formData && !isWaitingForStartPointDocuments && (!isSignScreen || hasText);

  useEffect(() => {
    if (!isWaitingForStartPointDocuments) {
      return;
    }

    const reloadInterval = window.setInterval(() => {
      window.location.reload();
    }, 10000);

    return () => {
      window.clearInterval(reloadInterval);
    };
  }, [isWaitingForStartPointDocuments]);

  return (
    <section className="section anketa">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="anketa__container">
              {userMenu && formData?.show_menu ? (
                <div className="anketa__menu">
                  {userMenu.map(({url, title}: any) => (
                    <span
                      key={url}
                      className={cn("menu-item", {
                        "menu-item_active": url === formData.current_menu_url,
                      })}
                      onClick={() => {
                        handleUserMenuData({url});
                      }}
                    >
                      {title}
                    </span>
                  ))}
                </div>
              ) : (
                <></>
              )}
              <div className="anketa__form">
                {canRenderForm && (
                  <Form
                    security={security}
                    data={formData as any}
                    onSubmit={handleSubmit}
                    onBack={(url) => handleUserMenuData({url})}
                    formError={formError}
                    validationType="onSubmit"
                  >
                    {isSignScreen && (
                      <SignTextBlock
                        blockTitle={formData.block_title}
                        textHtml={formData.text_html}
                        hintHtml={formData.hint_html}
                        downloadUrl={formData.download_url}
                      />
                    )}
                    {contactMenu && (
                      <Contacts security={security} contactMenu={contactMenu}/>
                    )}
                  </Form>
                )}
                {formData && isWaitingForStartPointDocuments && (
                  <div>
                    Документы формируются, пожалуйста, подождите.
                    <br/>
                    Если страница не обновится в течение минуты - обновите её вручную или вернитесь по ссылке позже.
                  </div>
                )}
                {errorMessage && <h4>{errorMessage}</h4>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Anketa;
